
import { PuttSituation } from "@/types/golf";
import PuttingTestContainer from "./putting/test/PuttingTestContainer";

interface PuttingTestProps {
  situation: PuttSituation;
  onClose: () => void;
  refreshAfterToast?: () => void;
}

const PuttingTest = ({ situation, onClose, refreshAfterToast }: PuttingTestProps) => {
  // Just a wrapper component that passes the props to the real implementation
  return (
    <PuttingTestContainer 
      situation={situation} 
      onClose={onClose} 
      refreshAfterToast={refreshAfterToast} 
    />
  );
};

export default PuttingTest;
